export const RoutePlanningComponentName: string = 'routePlanning';
